module.exports = __webpack_public_path__ + "img/tenet.a3fd7e50.svg";